export default "__VITE_PUBLIC_ASSET__e0d31371__"